module.exports = __webpack_public_path__ + "assets/img/Tram_1.8a22525b.png";